import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import LandingPage from '../pages/LandingPage';
import Recursos from '../pages/Recursos';
import Reportes from '../pages/Reportes';
import ExplorarMockup from '../pages/ExplorarMockup';
import LiveRankings from '../pages/LiveRankings';
import PublicExplorerRankings from '../pages/PublicExplorerRankings';
import PodscopeProfileWaitlistPage from '../pages/PodscopeProfileWaitlistPage';
import PodscopeBrochurePage from '../pages/PodscopeBrochurePage';
import AgendaDemoPage from '../pages/AgendaDemoPage';
import SummaLandingPage from '../pages/SummaLandingPage';
import Footer from './Footer';
import MainNavbar from './MainNavbar';
import SummaNavbar from './SummaNavbar';
import SummaFooter from './SummaFooter';
import { ContactDialogProvider } from '../contexts/ContactDialogContext';
import ProductPage from '../pages/ProductPage';
import { PRODUCT_PAGES } from '../pages/productPages';
import ClientPage from '../pages/ClientPage';
import { CLIENT_PAGES } from '../pages/clientPages';
import PrivacyPolicy from '../pages/legal/PrivacyPolicy';
import TermsOfService from '../pages/legal/TermsOfService';

// Component to scroll to top on route change
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export const ROUTES_NAMES = {
    LANDING: '/',
    RANKING: '/ranking',
    RECURSOS: '/recursos',
    REPORTES: '/reportes',
    EXPLORAR: '/explorar',
    LIVE_RANKINGS: '/live',
    RANKINGS: '/rankings',
    PODSCOPE_PROFILE_WAITLIST: '/perfil-podscope',
    PODSCOPE_BROCHURE: '/contacto',
    AGENDA_DEMO: '/agenda-demo',
    PRODUCT_REPORTERIA: '/producto/reporteria',
    PRODUCT_INTELIGENCIA: '/producto/inteligencia',
    PRODUCT_VERIFICACION: '/producto/verificacion',
    PRODUCT_ANALIZA_LEGACY: '/producto/analiza-y-reporta',
    PRODUCT_ECOSISTEMA_LEGACY: '/producto/descubre-el-ecosistema',
    PRODUCT_VERIFICA_LEGACY: '/producto/verifica-menciones',
    CLIENT_MEDIOS: '/cliente/medios',
    CLIENT_AGENCIAS: '/cliente/agencias',
    CLIENT_AVISADOR: '/cliente/avisador',
    PRIVACY: '/legal/privacidad',
    TERMS: '/legal/terminos',
    SUMMA_LANDING: '/summa-landing',
};

const Layout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isSummaLanding = location.pathname === ROUTES_NAMES.SUMMA_LANDING;

    return (
        <ContactDialogProvider openContactDialog={() => navigate(ROUTES_NAMES.AGENDA_DEMO)}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '100vh',
                    width: '100%',
                }}
            >
                <ScrollToTop />
                {isSummaLanding ? <SummaNavbar /> : <MainNavbar />}
                <Box
                    component="main"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        width: '100%',
                        minWidth: 0,
                    }}
                >
                    <Box
                        sx={{
                            px: 0,
                            pt: 0,
                            pb: 0,
                            width: '100%',
                            maxWidth: '100%',
                            mx: 'auto',
                            minWidth: 0,
                        }}
                    >
                        <Routes>
                            <Route path={ROUTES_NAMES.LANDING} element={<LandingPage />} />
                            <Route
                                path={ROUTES_NAMES.SUMMA_LANDING}
                                element={<SummaLandingPage />}
                            />
                            <Route
                                path={ROUTES_NAMES.RANKING}
                                element={<PublicExplorerRankings />}
                            />
                            <Route path={ROUTES_NAMES.RECURSOS} element={<Recursos />} />
                            <Route path={ROUTES_NAMES.REPORTES} element={<Reportes />} />
                            <Route path={ROUTES_NAMES.EXPLORAR} element={<ExplorarMockup />} />
                            <Route path={ROUTES_NAMES.LIVE_RANKINGS} element={<LiveRankings />} />
                            <Route
                                path={ROUTES_NAMES.RANKINGS}
                                element={<Navigate to={ROUTES_NAMES.RANKING} replace />}
                            />
                            <Route
                                path={ROUTES_NAMES.PODSCOPE_PROFILE_WAITLIST}
                                element={<PodscopeProfileWaitlistPage />}
                            />
                            <Route
                                path={ROUTES_NAMES.PODSCOPE_BROCHURE}
                                element={<PodscopeBrochurePage />}
                            />
                            <Route path={ROUTES_NAMES.AGENDA_DEMO} element={<AgendaDemoPage />} />
                            <Route
                                path={ROUTES_NAMES.PRODUCT_REPORTERIA}
                                element={<ProductPage content={PRODUCT_PAGES.reporteria} />}
                            />
                            <Route
                                path={ROUTES_NAMES.PRODUCT_INTELIGENCIA}
                                element={<ProductPage content={PRODUCT_PAGES.inteligencia} />}
                            />
                            <Route
                                path={ROUTES_NAMES.PRODUCT_VERIFICACION}
                                element={<ProductPage content={PRODUCT_PAGES.verificacion} />}
                            />
                            <Route
                                path={ROUTES_NAMES.CLIENT_MEDIOS}
                                element={<ClientPage content={CLIENT_PAGES.medios} />}
                            />
                            <Route
                                path={ROUTES_NAMES.CLIENT_AGENCIAS}
                                element={<ClientPage content={CLIENT_PAGES.agencias} />}
                            />
                            <Route
                                path={ROUTES_NAMES.CLIENT_AVISADOR}
                                element={<ClientPage content={CLIENT_PAGES.avisador} />}
                            />
                            <Route
                                path="/cliente/marcas"
                                element={<Navigate to={ROUTES_NAMES.CLIENT_AVISADOR} replace />}
                            />
                            <Route
                                path={ROUTES_NAMES.PRODUCT_ANALIZA_LEGACY}
                                element={<Navigate to={ROUTES_NAMES.PRODUCT_REPORTERIA} replace />}
                            />
                            <Route
                                path={ROUTES_NAMES.PRODUCT_ECOSISTEMA_LEGACY}
                                element={
                                    <Navigate to={ROUTES_NAMES.PRODUCT_INTELIGENCIA} replace />
                                }
                            />
                            <Route
                                path={ROUTES_NAMES.PRODUCT_VERIFICA_LEGACY}
                                element={
                                    <Navigate to={ROUTES_NAMES.PRODUCT_VERIFICACION} replace />
                                }
                            />
                            <Route path={ROUTES_NAMES.PRIVACY} element={<PrivacyPolicy />} />
                            <Route path={ROUTES_NAMES.TERMS} element={<TermsOfService />} />
                            <Route
                                path="*"
                                element={<Navigate to={ROUTES_NAMES.LANDING} replace />}
                            />
                        </Routes>
                    </Box>
                </Box>
                {isSummaLanding ? <SummaFooter /> : <Footer />}
            </Box>
        </ContactDialogProvider>
    );
};

export default Layout;
